<div class="summary" role="group" aria-label="Resumo do dicionário">
  <button
    type="button"
    class="summary__item"
    [class.summary__item--attention]="(toReview() ?? 0) > 0"
    [class.summary__item--current]="section() === 'review'"
    data-testid="dictionary-summary-to-review"
    (click)="sectionRequested.emit('review')">
    <span class="summary__label">A revisar</span>
    <span class="summary__value">{{ toReview() ?? '–' }}</span>
  </button>
  <button
    type="button"
    class="summary__item"
    [class.summary__item--current]="section() === 'pending'"
    data-testid="dictionary-summary-pending"
    (click)="sectionRequested.emit('pending')">
    <span class="summary__label">Pendentes</span>
    <span class="summary__value">{{ pending() ?? '–' }}</span>
  </button>
  <button
    type="button"
    class="summary__item"
    [class.summary__item--current]="section() === 'versions'"
    data-testid="dictionary-summary-version"
    (click)="sectionRequested.emit('versions')">
    <span class="summary__label">Versão em uso</span>
    <span class="summary__value">
      {{ activeVersionNumber() ? 'v' + activeVersionNumber() : '–' }}
    </span>
  </button>
</div>
